module.exports = __webpack_public_path__ + "static/img/查报告@3x.9901dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/查报告@3x.png
// module id = 776
// module chunks = 358